// extracted by mini-css-extract-plugin
export var background = "_404-module--background--8OJzw";
export var button = "_404-module--button--p6NGc";
export var image = "_404-module--image--wnGLO";
export var imageWrapper = "_404-module--imageWrapper--2gQ1x";
export var label = "_404-module--label--2GLFj";
export var title = "_404-module--title--JYYaA";
export var wrapper = "_404-module--wrapper--8GWgw";